import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import {
  getWelcomeMatClosedForWrongCountry,
  getWelcomeMatClosedForCorrectCountry,
  setWelcomeMatClosedForCorrectCountry,
  setWelcomeMatClosedForWrongCountry
} from "asos-site-chrome-store-presentation";
import IconButton from "../IconButton";
import Message from "./Message";
import ValueProposition from "./ValueProposition";
import PaymentOptions from "./PaymentOptions";
import styles from "./WelcomeMat.css";
import withTranslation from "../translation";
import { getContext } from "../../../client/context";

class WelcomeMat extends PureComponent {
  static propTypes = {
    country: PropTypes.shape({
      imageUrl: PropTypes.string,
      name: PropTypes.string
    }),
    formatTranslation: PropTypes.func.isRequired,
    isCorrectCountry: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.string),
    paymentOptions: PropTypes.arrayOf(PropTypes.object),
    platform: PropTypes.string,
    redirectUrl: PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string
    }),
    requestWelcomeMat: PropTypes.func.isRequired,
    text: PropTypes.string,
    valueHeader: PropTypes.string,
    welcome: PropTypes.string
  };

  state = {
    isClosed: false
  };

  shouldRequestWelcomeMatData() {
    const { isCorrectCountry } = this.props;
    const hasCookieForCountry = isCorrectCountry
      ? getWelcomeMatClosedForCorrectCountry
      : getWelcomeMatClosedForWrongCountry;
    return !hasCookieForCountry();
  }

  componentDidMount() {
    const { requestWelcomeMat, platform } = this.props;

    if (this.shouldRequestWelcomeMatData()) {
      requestWelcomeMat(platform);
    }
  }

  close = () => {
    const { isCorrectCountry } = this.props;

    if (!isCorrectCountry) {
      setWelcomeMatClosedForWrongCountry(true);
    }

    this.setState({
      isClosed: true
    });
  };

  render() {
    const {
      country,
      formatTranslation,
      isCorrectCountry,
      messages,
      paymentOptions,
      redirectUrl,
      text,
      valueHeader,
      welcome
    } = this.props;
    const { isClosed } = this.state;

    if (isClosed || !redirectUrl || !getContext()) {
      return null;
    }

    if (isCorrectCountry) {
      setWelcomeMatClosedForCorrectCountry(true);
    }

    const { imageUrl, name: imageLabel } = country;

    return (
      <div className={styles.container}>
        <div className={styles.containerWrapper}>
          <div className={styles.titleBarWrapper}>
            <div className={styles.titleBar}>
              <div className={styles.title}>{welcome}</div>
              <IconButton
                icon="close"
                className={styles.closeButton}
                data-testid="close-button"
                onClick={this.close}
                aria-label={formatTranslation("Icon.Close")}
              />
            </div>
          </div>
          <div className={styles.contentBarWrapper}>
            <div className={styles.contentBar}>
              <Message
                text={text}
                redirectUrl={redirectUrl}
                imageUrl={imageUrl}
                imageLabel={imageLabel}
                withCountrySelector={isCorrectCountry}
                targetCountryCode={country.countryCode}
              />
              {messages && messages.length > 0 && (
                <ValueProposition messages={messages} header={valueHeader} />
              )}
              {paymentOptions.length > 0 && (
                <PaymentOptions paymentOptions={paymentOptions} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation(WelcomeMat);
